// extracted by mini-css-extract-plugin
export default {"products":"CF-z","oosMessaging":"DF-z"};